import { MButton } from '@Components/Base';
import Flex from 'antd/es/flex';
import Space from 'antd/es/space';
import Text from 'antd/es/typography/Text';
import classNames from 'classnames';
import { FC, useContext, useMemo } from 'react';
import { useFormikContext } from 'formik';
import { NotificationContext } from '@Context/NotificationContext';
import { ComparisonSheetState } from '../ComparisonSheet.types';
import styles from './PriceComparisonFooter.module.css';

interface PriceComparisonFooterProps {
  handleReviewApprove: () => void;
  handleSave?: () => void;
  finalAmount?: number;

  onUnlockPricing?: () => void;
  handlePriceBreakdown: () => void;
}
const PriceComparisonFooter: FC<PriceComparisonFooterProps> = ({
  handleReviewApprove,
  handleSave,
  onUnlockPricing,
  finalAmount = 0,
  handlePriceBreakdown,
}) => {
  const { errorNotification } = useContext(NotificationContext);
  const formik = useFormikContext<ComparisonSheetState>();

  const uniqSelectionNumber = useMemo(() => {
    const uniq = formik.values.selectedOffersIDs?.length
      ? Array.from(
          new Map(
            formik.values.selectedOffersIDs.map(({ matId, vendorId }) => [
              matId,
              vendorId,
            ])
          ).keys()
        ).length
      : 0;
    return uniq;
  }, [formik.values.selectedOffersIDs]);

  const isShowErrorSplit = useMemo(() => {
    const allOffers = formik.values.allOffers?.length;
    if (uniqSelectionNumber === allOffers) {
      return false;
    }
    return true;
  }, [uniqSelectionNumber, formik.values.allOffers]);

  const onReviewApprove = (): void => {
    if (isShowErrorSplit) {
      errorNotification('Please select at least one vendor for all materials');
      return;
    }
    handleReviewApprove();
  };

  return (
    <Flex justify="space-between" className={classNames(styles.footer)}>
      <Space>
        <Flex vertical>
          <Text>
            Final Amount ({uniqSelectionNumber || 0} of{' '}
            {formik.values.allOffers?.length || 0} selected)
          </Text>
          <Flex gap={5}>
            <Text strong>{finalAmount} AED</Text>
            <Text>/</Text>
            <Text
              className={styles.priceBreakdown}
              onClick={handlePriceBreakdown}
            >
              Price Breakdown
            </Text>
          </Flex>
        </Flex>
      </Space>
      <Space>
        {!formik.values.disabledItems?.disableUnlockPricing && (
          <MButton
            type="text"
            className={styles.cancelButton}
            onClick={onUnlockPricing}
          >
            Unlock Pricing
          </MButton>
        )}
        <MButton type="secondary" onClick={handleSave}>
          Save as Draft
        </MButton>
        <MButton type="primary" onClick={onReviewApprove}>
          Review & Approve
        </MButton>
      </Space>
    </Flex>
  );
};
export default PriceComparisonFooter;
